import { CAST_AI } from '@cast/constants';
import { InstallableKentFeature } from '@cast/types-kent';

import { AgentSetupBlock } from 'hooks/dialogs/cluster/components/features';

const KentFeatureTypeToTitleMap: Record<
  InstallableKentFeature['type'],
  string
> = {
  POD_MUTATIONS: 'Pod mutations',
  REBALANCING: 'Rebalancer',
  WORKLOAD_RIGHT_SIZING: 'Workload autoscaler',
  SPOT_INTERRUPTION_PREDICTION: 'Spot interruption prediction',
  CLM: 'Container live migration',
};

const KentFeatureTypeToDescriptionMap: Record<
  InstallableKentFeature['type'],
  string
> = {
  POD_MUTATIONS:
    'Applies template-based modifications to Pod specifications at creation time, eliminating repetitive manual configuration.',
  REBALANCING:
    'Replaces Nodes with more cost-efficient alternatives using live container migration to prevent downtime.',
  WORKLOAD_RIGHT_SIZING: `Run cost-effective workloads on peak performance with ${CAST_AI}'s workload optimization.`,
  SPOT_INTERRUPTION_PREDICTION: `${CAST_AI} predicts and handles Spot interruptions by proactively migrating workloads before instances terminate.`,
  CLM: 'Seamlessly relocates stateful workloads across nodes with zero disruption',
};

type Props = {
  testId?: string;
  featureType: InstallableKentFeature['type'];
  hasBeenInstalled: boolean;
  checked: boolean;
  onToggle?: () => void;
  readonly?: boolean;
};

export const KentFeatureItem = ({
  testId,
  featureType,
  hasBeenInstalled,
  checked,
  onToggle,
  readonly,
}: Props) => {
  return (
    <AgentSetupBlock
      testId={testId}
      readonly={readonly}
      checked={checked}
      hasBeenInstalled={hasBeenInstalled}
      isNestedBlock
      heading={KentFeatureTypeToTitleMap[featureType]}
      description={KentFeatureTypeToDescriptionMap[featureType]}
      onChange={onToggle}
    />
  );
};
